// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"233":"e288dd42","615":"c11801cb","688":"692c9078"}[chunkId] || chunkId) + "." + {"233":"dd5de527ba39ac07","615":"587e770dec2420ff","617":"73baac40c5c8e52f","688":"73f92d32b095d96f"}[chunkId] + ".js";
};